define('ACS.ACSPLPStyles.Main', [
	'Facets.ItemCell.View',
	'underscore',
	'Profile.Model'
], function (
	facetsItemCell,
	_,
	ProfileModel)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var layout = container.getComponent('Layout');
			var self = this;
			_.extend(facetsItemCell.prototype, {
				getContext: _.wrap(facetsItemCell.prototype.getContext, function (fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					context.isDesktop = self.isDesktop();
					context.storedescription = this.model.get('storedescription');
					if (!ProfileModel.getInstance().hidePrices()) {
						context.customerPriceFormatted = this.model.get('onlinecustomerprice_detail').onlinecustomerprice_formatted;
					}

					return context;
				})
			});

		},
		isDesktop: function isDesktop() {
            var screenWidth = window && window.screen && window.screen.width;
            var screenHeight = window && window.screen && window.screen.height;

            return screenWidth >= 768 && screenHeight >= 481;
        }
	};
});
